import React, { useCallback } from 'react';

import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';

import API from 'utils/api';
import { useSources } from 'hooks';
import { ButtonContainer, Table } from 'components';
import { backLink } from 'utils';

import styles from './Inbox.module.scss';

const SentMessages = props => {
  const userId = _.get(props, 'location.state.user');
  const userName = _.get(props, 'location.state.userName');

  const sources = useSources();

  const fetchData = useCallback(
    ({ filter, ...rest }) =>
      API.getInboxSentMessages(
        userId,
        {
          ...rest,
          query: filter
            ? JSON.stringify(
                _.mapValues(filter, value => ({ $regex: value, $options: 'i' }))
              )
            : undefined,
          select: 'body curDate',
        },
        sources
      ),
    [sources, userId]
  );

  return (
    <div className={styles.inbox}>
      <ButtonContainer position="top">
        <Button variant="text" component={Link} to={backLink(props)}>
          back to inbox
        </Button>
      </ButtonContainer>

      <Table
        data={fetchData}
        title={`Messages sent to @${userName}`}
        filtering
        pageSizeOptions={[5, 10, 20, 40]}
        pageSize={10}
        search={false}
        refreshButton
        columns={[
          { title: 'Message', field: 'body.text', weight: 4 },
          {
            title: 'Date',
            field: 'createdAt',
            align: 'center',
            initialSort: 'desc',
            defaultSort: 'desc',
            filtering: false,
            render: ({ curDate }) => (
              <div>{moment(curDate).format('YYYY/MM/DD hh:mm A')}</div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default SentMessages;
